import jQuery from 'jquery';

//import './components';
//import './searchlanding.js'

$(document).ready(function () {
    
    setTimeout(function () {
        $(".header").find('a').each(function () {
            if ($(this).attr('href') != null) {
                if (
                    !$(this).attr('href').startsWith('/') &&
                    !$(this).attr('href').startsWith('mail') &&
                    !$(this).attr('href').startsWith('javascript')
                ) {
                    $(this).append('<svg aria-hidden="true" focusable="false"><use xlink:href="/images/svg-sprite.svg#icons-external"></use></svg>');
                }
                if ($(this).attr('href').indexOf('globalassets') >= 0) {
                    $(this).addClass('CTAFile');
                }
            }
        });
    }, 500);


    setTimeout(function () {
        $(".VideoOverlay").each(function (index) { $(this).addClass("MCKvideo" + index) });
        for (var i = 0; i < $('.VideoOverlay').length; i++) {
            videoButtons(i)
        }

    }, 1500);
});


function videoButtons(index){
    if ($('.VideoOverlay').length > 0) {
        var video = VidyardV4.players[index];
        var pause = 0
        video.on("playerComplete", function () {
            $(".MCKvideo" + index).show()
            $('.slider-video__content').show()
        });
        // When the video is paused, change flag to 1

        video.on("pause", function () {
            pause = 1;

        });

        // When the video is first played or resumed, change flag to 0

        video.on("play", function () {
            pause = 0;
            $(".MCKvideo" + index).hide()
            $('.slider-video__content').hide()
        });

        // When the button is clicked, check the flag and perform the appropriate action.


        $(".MCKvideo" + index)
            .on("click", function () {
                video.play();
            })
            .on("keydown", function (e) {
                if (e.key === "Enter" || e.key === " " || e.keyCode === 13 || e.keyCode === 32) {
                    e.preventDefault();
                    video.play();
                }
            });



    }

}